export * from '@fhs/routing/src/routes/redeem/index';
export { default } from '@fhs/routing/src/routes/redeem/index';
